import { ArtistFestivalType } from '@api';
import { FestivalAnchor, formatDate } from '@common';
import { Stack, Text } from '@mantine/core';

type FestivalTableCellPropsType = {
  record: ArtistFestivalType;
};

export const FestivalTableCell: React.FC<FestivalTableCellPropsType> = ({
  record,
}) => {
  return (
    <Stack gap={0}>
      <FestivalAnchor festival={record.festival} />
      <Text>{formatDate(record.date)}</Text>
    </Stack>
  );
};
